export default "__VITE_ASSET__DaD6rd4L__"